import { privateRequest, referralRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    CUSTOMER_DETAILS: "api/CRM/Leads",
    DELETE_CUSTOMER: "api/CRM/Lead",
    ASSIGN_LEAD: "api/CRM/AssignLead",
    TIMELINE_COMMENT: "api/CRM/CommentOnLeadTransactions",
    MEETING_ANALYSIS: "api/CRM/MeetingAnalysis",
    STATUS_LIST: "api/CRM/LeadStatus",
    CUSTOMER_CONFIGURATION: "api/CustomerConfigurationCustomFields",
    ASSIGN_ROASTER: "api/CRM/AssignLeadRoster",
    ACTION_POINT_LIST: "api/CRM/ActionPointsV1",
    ADD_NEW_CUSTOMER: "api/CRM/Lead",
    CUSTOM_FIELDS: "api/CustomFields",
    CUSTOMER_DATA: "api/CRM/LeadWithProduct",
    UPDATE_CUSTOMER_DETAILS: "api/CRM/Lead",
    LEAD_SOURCE: "api/CRM/LeadSource",
    LEAD_STAGE: "api/CRM/LeadStage",
    LEAD_TYPE: "api/CRM/LeadType",
    TERRITORIES: "api/CRM/Territories",
    REFFERED_USER: "/referral/ReferralUser/ApprovedReferralUsers",
    BULK_ASSIGN: "api/CRM/BulkAssignLead",
    LEADBYNEXTLEADTYPE: "api/CRM/LeadsByNextLeadType",
    GET_DISTRIBUTORS: "api/CRM/Distributors",
    APPROVE_DISTRIBUTOR: "api/CRM/ApprovedDistributor",
    DISTRIBUTOR_SIGNUP_LINK: "api/Account/DistributorSignUpLink",
    EXCEL_EXPORT: "api/CRM/ExportToExcel",
    CUSTOMER_BULK_UPLOAD: "api/CRM/LeadsBulkUpload",
    GET_LEAD_DESIGNATION: "api/CRM/LeadDesignations",
    GET_CRM_SETTING: "api/CRM/CRMSetting",
    GET_LEAD_CONTACT: "api/CRM/LeadContacts",
    GET_ADDRESS: "api/AddressByLatLong",
    SHOW_FILE: "api/CRM/Customer/BulkUpload/ShowFile",
    VIEW_REPORT: "api/CRM/Customer/BulkUpload/ViewReport",
    EXPORT_BULK_REPORT: "api/CRM/Customer/BulkUpload/ExportViewReport",
    EXPORT_BULK_FILE: "api/CRM/Customer/BulkUpload/ExportReport",
    AUDIT_LOG: "api/CRM/Lead/AuditLogs",
    CRM_TRANSACTION_NOTES: "api/CRM/transaction-notes/upload",
    VIEW_TRANSACTION_REPORT: "api/CRM/LeadTransaction/ViewReport",
    EXPORT_TRANSACTION_BULK_FILE: "api/CRM/LeadTransaction/ExportReport",
    GET_LEAD_REQUEST : "api/CRM/LeadRequest",
    UPADTE_LEAD_REQUEST: "api/CRM/ReviewLeadRequest",
    GET_LEADREQUEST_DETAIL:"api/CRM/LeadApprovalRequestDetail"
}

export const getCustomersDetails = async (payload: any): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.post<ApiResponse<any[]>>(`${ENDPOINTS.CUSTOMER_DETAILS}`, payload);
    return res.data;
}

export const deleteCustomer = async (customerId: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(`${ENDPOINTS.DELETE_CUSTOMER}/${customerId}`)
    return res.data
}

export const assignLead = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.ASSIGN_LEAD}`, payload);
    return res.data;
}

export const commentOnLeadTransactions = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.TIMELINE_COMMENT}`, payload);
    return res.data;
}

export const getMeetingAnalysis = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.MEETING_ANALYSIS}`, payload);
    return res.data;
}

export const getStatusList = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.STATUS_LIST);
    return res.data;
}

export const getCustomerConfigurationCustomFields = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.CUSTOMER_CONFIGURATION}`);
    return res.data;
}

export const assignLeadRoster = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.ASSIGN_ROASTER}`, payload);
    return res.data;
}

export const getActionPointList = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.ACTION_POINT_LIST}`);
    return res.data;
}

export const addNewCustomer = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.ADD_NEW_CUSTOMER}`, payload);
    return res.data;
}

export const updateCustomerDetails = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.put<ApiResponse<any>>(`${ENDPOINTS.UPDATE_CUSTOMER_DETAILS}`, payload);
    return res.data;
}

export const getCustomFields = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.CUSTOM_FIELDS}`);
    return res?.data;
}

export const getCustomerData = async (leadId: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.CUSTOMER_DATA, { params: { leadId } });
    return res.data;
}

export const getLeadSource = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.LEAD_SOURCE}`);
    return res.data;
}

export const getLeadType = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.LEAD_TYPE}`);
    return res.data;
}

export const getLeadStage = async (): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.get<ApiResponse<any[]>>(`${ENDPOINTS.LEAD_STAGE}`);
    return res?.data;
}

export const getTerritories = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.TERRITORIES}?from=1&text=&to=-1`);
    return res.data;
}

export const getReferalUser = async (): Promise<ApiResponse<any>> => {
    const res = await referralRequest.get<ApiResponse<any>>(`${ENDPOINTS.REFFERED_USER}`);
    return res.data;
}

export const assignBulkCustomer = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.BULK_ASSIGN}`, payload);
    return res.data;
}

export const getLeadbyNextLeadType = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.LEADBYNEXTLEADTYPE}`, payload);
    return res.data;
}

export const getDistributor = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.GET_DISTRIBUTORS}`, payload);
    return res.data;
}

export const approveDistributor = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.APPROVE_DISTRIBUTOR}`, payload);
    return res.data;
}

export const distributorSignupLink = async (): Promise<ApiResponse<string>> => {
    const res = await privateRequest.get<ApiResponse<string>>(ENDPOINTS.DISTRIBUTOR_SIGNUP_LINK);
    return res.data;
}

export const ExportCustomerReport = async (payload: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXCEL_EXPORT}`, payload, {
        responseType: "arraybuffer"
    });
    return res;
}

export const CustomerBulkUpload = async (payload: any): Promise<any> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.CUSTOMER_BULK_UPLOAD}`, payload);
    return res.data;
}

export const getLeadDesignations = async (): Promise<any> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_LEAD_DESIGNATION);
    return res.data;
};

export const getCRMSettings = async (): Promise<any> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_CRM_SETTING);
    return res.data;
};

export const getLeadContacts = async (): Promise<any> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_LEAD_CONTACT);
    return res.data;
};

export const getAddress = async (data: any): Promise<any> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_ADDRESS, { params: data });
    return res.data;
}

export const getCustomerBulkReport = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.SHOW_FILE, { params: payload });
    return res.data;
}

export const viewCustomerBulkReport = async (payload: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.VIEW_REPORT, { params: payload });
    return res.data;
}

const exportCustomerBulkUploadReport = async (fileId: number) => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPORT_BULK_REPORT}/${fileId}`, {}, { responseType: "arraybuffer" });
    return res;
};

const exportCustomerBulkUploadFile = async (fileId: number) => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPORT_BULK_FILE}/${fileId}`, {}, { responseType: "arraybuffer" });
    return res;
};

const getAuditLog = async (params: any, signal?: AbortSignal) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.AUDIT_LOG, {
        params,
        ...(signal ? { signal } : {}),
    });
    return res;
}

const uploadCRMTransactionNotes = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.CRM_TRANSACTION_NOTES, data);
    return res.data;
};

const exportTransactionBulkUploadFile = async (fileId: number) => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPORT_TRANSACTION_BULK_FILE}/${fileId}`, {}, { responseType: "arraybuffer" });
    return res;
};

const viewTransactionBulkReport = async (payload: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.VIEW_TRANSACTION_REPORT, { params: payload });
    return res.data;
};

const updateLeadRequest = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.put<ApiResponse<any>>(`${ENDPOINTS.UPADTE_LEAD_REQUEST}`,data);
  return res.data;
};

const getLeadRequestData = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.GET_LEAD_REQUEST}`, { params: data });
  return res.data;
};

const getLeadRequestDetail = async (requestId: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.GET_LEADREQUEST_DETAIL}?requestId=` + requestId);
    return res.data;
}

const CustomerService = {
    getCustomersDetails,
    deleteCustomer,
    assignLead,
    commentOnLeadTransactions,
    getMeetingAnalysis,
    getStatusList,
    getCustomerConfigurationCustomFields,
    assignLeadRoster,
    getActionPointList,
    addNewCustomer,
    getCustomFields,
    getCustomerData,
    updateCustomerDetails,
    getLeadSource,
    getLeadStage,
    getLeadType,
    getTerritories,
    getReferalUser,
    assignBulkCustomer,
    getLeadbyNextLeadType,
    getDistributor,
    approveDistributor,
    distributorSignupLink,
    ExportCustomerReport,
    CustomerBulkUpload,
    getLeadDesignations,
    getCRMSettings,
    getLeadContacts,
    getAddress,
    getCustomerBulkReport,
    viewCustomerBulkReport,
    exportCustomerBulkUploadReport,
    exportCustomerBulkUploadFile,
    getLeadRequestData,
    updateLeadRequest,
    getLeadRequestDetail,
    getAuditLog,
    uploadCRMTransactionNotes,
    exportTransactionBulkUploadFile,
    viewTransactionBulkReport,
}

export default CustomerService